import "./components/menu";

let initStickyMenu = () => {
  if (window.pageYOffset > 1) {
    document.querySelector(".ox-header").classList.add("ox-header--sticky");
    document.body.classList.add("ox-u-sticky-heder");
  } else {
    document.querySelector(".ox-header").classList.remove("ox-header--sticky");
    document.body.classList.remove("ox-u-sticky-heder");
  }
};

window.smoothScroll = function(target) {
  var scrollContainer = target;
  do { //find scroll container
      scrollContainer = scrollContainer.parentNode;
      if (!scrollContainer) return;
      scrollContainer.scrollTop += 1;
  } while (scrollContainer.scrollTop == 0);

  var targetY = 0;
  do { //find the top of target relatively to the container
      if (target == scrollContainer) break;
      targetY += target.offsetTop;
  } while (target = target.offsetParent);

  scroll = function(c, a, b, i) {
      i++; if (i > 30) return;
      c.scrollTop = a + (b - a) / 30 * i;
      setTimeout(function(){ scroll(c, a, b, i); }, 20);
  }
  // start scrolling
  scroll(scrollContainer, scrollContainer.scrollTop, targetY, 0);
}

initStickyMenu();
document.addEventListener("scroll", initStickyMenu, {
  capture: false,
  passive: true
});

const filter = document.querySelector(".ox-videos-filter-container");
if (filter) {
  const filterPos = filter.offsetTop;
  window.onscroll = function() {
    let topPos = filter.getBoundingClientRect().top;
    let headerHeight = 85;
    let filterElHeight = document.querySelector(".ox-header").clientHeight;
    let minScreenWidth = 1280;
    let globalElem = document.querySelector(".ox-u-global-overflow-hidden");

    if (
      topPos <= headerHeight &&
      window.pageYOffset >= filterPos - filterElHeight &&
      window.innerWidth >= minScreenWidth
    ) {
      filter.classList.add("ox-videos-filter-container--active");
      globalElem.style.padding = filterElHeight + "px 0 0 0";
    } else {
      filter.classList.remove("ox-videos-filter-container--active");
      globalElem.style.padding = 0;
    }
  };
}

const heroScrollBtn = document.querySelector(".ox-hero__scroll-btn");
if (heroScrollBtn) {
  heroScrollBtn.addEventListener("click", function() {
    scrollTo(document.getElementById("ox-scroll-to"));
  });
}

function scrollTo(element) {
  window.scroll({
    behavior: "smooth",
    left: 0,
    top: element.offsetTop - 85
  });
}

/* Cookie **/

let cookieElement = document.querySelector(".ox-cookie-bar");
let expireDays = cookieElement ? cookieElement.getAttribute("data-expire") : 0;
let cookieConfirm = document.querySelector(".ox-cookie-bar__confirm");

if (cookieConfirm) {
  cookieConfirm.addEventListener("click", function() {
    setCookie("cookiesBar", 1, expireDays);
    cookieElement.style.display = "none";
  });
}

if (getCookie("cookiesBar") != 1 && cookieElement) {
  cookieElement.style.display = "flex";
}

function setCookie(cname, cvalue, expireDays) {
  var d = new Date();
  d.setTime(d.getTime() + (expireDays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

if (document.querySelector('.ox-intro') && getCookie("introSlider") != 1) {
  document.querySelector('.ox-intro').style.display = "flex";
  document.querySelector('body').style.overflow = "hidden";
  var introSlide = 2;

  setTimeout(() => {
    document.querySelector('.ox-intro .ox-intro__loading-bar > span').style.width = "100%";
    document.querySelector('.ox-intro *[data-slide="1"]').style.maxHeight = "70rem";

    setTimeout(() => {
    introInterval();
    }, 1500);
  }, 1200);



  document.querySelector('.ox-intro__loading-bar-container').addEventListener("click", function() {
    hideIntroSlider();
  });
}

function hideIntroSlider() {
  setTimeout(function() {
    document.querySelector('.ox-intro').style.display = "none";
    document.querySelector('body').style.overflow = "auto";
  }, 600);
  document.querySelector('.ox-intro').style.opacity = "0";
  setCookie("introSlider", 1, 1);
}

function introInterval() {
  if (introSlide <= 4) {

    setTimeout(() => {
      document.querySelector('.ox-intro *[data-slide="'+introSlide+'"]').style.maxHeight = "70rem";
      document.querySelector('.ox-intro *[data-slide-num="'+(introSlide - 1)+'"]').style.top = "2.5rem";
      document.querySelector('.ox-intro *[data-slide-num="'+introSlide+'"]').style.top = "0";
      introSlide ++;
    }, 1500);

    document.querySelector('.ox-intro *[data-slide="'+(introSlide - 1)+'"]').style.maxHeight = "0px";

    setTimeout(introInterval, 3000);
    console.log(introSlide);

    if (introSlide == 4) {
      setTimeout(() => {
        document.querySelector('.ox-intro__video').style.opacity = "0";
      }, 2500);
      setTimeout(() => {
        hideIntroSlider()
      }, 4000);
    }
  }
}

function hideCategoriesMenu() {
  document.querySelector('.ox-videos-filter.ox-videos-filter--full-width').style.maxHeight = "6.1rem";
  document.querySelector('.ox-videos-filter_angle--up').style.display = "none";
  document.querySelector('.ox-videos-filter_angle--down').style.display = "block";
}

function openCategoriesMenu() {
  document.querySelector('.ox-videos-filter.ox-videos-filter--full-width').style.maxHeight = "100vh";
  document.querySelector('.ox-videos-filter_angle--up').style.display = "block";
  document.querySelector('.ox-videos-filter_angle--down').style.display = "none";
}

document.querySelector('.ox-videos-filter_angle--up').addEventListener("click", function() {
  hideCategoriesMenu();
});
document.querySelector('.ox-videos-filter_angle--down').addEventListener("click", function() {
  openCategoriesMenu();
});

hideCategoriesMenu();
